import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Information} from '../model/information';
import {CommonService} from './common.service';

@Injectable({
  providedIn: 'root'
})
export class InformationsService extends CommonService<Information> {
  constructor(http: HttpClient) {
    super(http, '/informations', true);
  }

  purgeArchive(): void {
    this.http.delete<void>(`${environment.backend}${this.url}`).subscribe(() => {
      this.objects = this.objects.filter(data => {
        return data.type !== 'ARCHIVED';
      });
      this.subject.next(this.objects);
    });
  }

  sort(objs: Information[]): Information[] {
    return objs.sort(Information.compare);
  }
}
